import { Component, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-nav-tab',
  templateUrl: './nav-tab.component.html',
})
export class NavTabComponent {
  @Input() title: string | undefined;
  @Input() itemId: number | undefined;
  @Input() isChecked: boolean = false;
  @Input() showIndicator: boolean = false;
  @ContentChild(TemplateRef, { static: true }) content!: TemplateRef<any>;
}
